import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, DataTable, GhostButton } from "@/components/admin/ui";
import MarkPaidDialog from "@/components/admin/MarkPaidDialog";
import { useFetch } from "@/hooks/useFetch";
import { formatDate } from "@/lib/api";
import { Pill, STUDENT_STATUS, CLASSES } from "@/lib/status";

export default function Students() {
  const [cls, setCls] = useState("all");
  const [q, setQ] = useState("");
  const [paying, setPaying] = useState(null);
  const { data, loading, reload } = useFetch(`/admin/students?q=${encodeURIComponent(q)}${cls !== "all" ? `&class_level=${cls}` : ""}`);
  return (
    <div data-testid="students-page">
      <PageHeader eyebrow="Families" title="Students" description="Every student profile with its consent, payment and assessment status." />
      <div className="flex flex-wrap gap-3 mb-4">
        <Input placeholder="Search student name" value={q} onChange={(e) => setQ(e.target.value)} className="h-10 bg-white max-w-xs" data-testid="students-search-input" />
        <Select value={cls} onValueChange={setCls}>
          <SelectTrigger className="h-10 w-40 bg-white" data-testid="students-class-filter"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-white"><SelectItem value="all">All classes</SelectItem>{CLASSES.map((c) => <SelectItem key={c} value={String(c)}>Class {c}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      <DataTable testId="students-table" loading={loading} rows={data} columns={[
        { key: "name", label: "Student", render: (r) => <span className="font-semibold">{r.name}</span> },
        { key: "class_level", label: "Class" },
        { key: "parent_email", label: "Parent", render: (r) => <Link to={`/admin/parents/${r.parent_id}`} className="text-[#4F0341] link-underline">{r.parent_email}</Link> },
        { key: "school_name", label: "School", render: (r) => r.school_name || "-" },
        { key: "status", label: "Status", render: (r) => <Pill map={STUDENT_STATUS} value={r.status} /> },
        { key: "created_at", label: "Added", render: (r) => formatDate(r.created_at) },
        { key: "a", label: "", render: (r) => !r.is_paid && <GhostButton onClick={() => setPaying(r)} data-testid={`students-mark-paid-${r.id}`}>Mark paid</GhostButton> },
      ]} />
      <MarkPaidDialog student={paying} onClose={() => setPaying(null)} onDone={reload} />
    </div>
  );
}
